import { Instagram, Youtube, Facebook, Twitter } from 'lucide-react';

export const PRICING_TIERS = {
    monthly: {
        id: 'price_1SrREDKHy89O5QxfQQB4HIZA',
        label: 'Monthly Plan',
        price: '$199/mo'
    },
    yearly: {
        id: 'price_1SrREBKHy89O5QxfRHoErlko',
        label: 'Yearly Plan',
        price: '$1199/yr',
        discount: 'Save 20%'
    }
};

const RELEASE_TYPES = [
    'Theatrical Wide',
    'Theatrical Limited / Platform',
    'Festival Premiere',
    'Streaming / VOD',
    'Hybrid (Theatrical + Streaming)',
    'TBD'
];

export const GENRES = [
    "Action", "Horror", "Drama", "Comedy", "Documentary", 
    "Sci-Fi", "Thriller", "Social Thriller", "Lo-fi Sci-fi", "Action-Horror"
];

export const BUDGET_LEVELS = [
    "Micro (<$500k)", "Indie ($500k - $5M)", "Mid-Tier ($5M - $50M)", "Studio (>$50M)"
];

export const PLATFORMS = {
    instagram: { name: "Instagram", color: "bg-pink-500", brandIcon: Instagram, baseUrl: "https://www.instagram.com/" },
    tiktok: { name: "TikTok", color: "bg-cyan-400", brandIcon: null, baseUrl: "https://www.tiktok.com/@" }, // Note: SVG icons might need special handling if moved
    youtube: { name: "YouTube", color: "bg-red-600", brandIcon: Youtube, baseUrl: "https://www.youtube.com/" },
    facebook: { name: "Facebook", color: "bg-blue-600", brandIcon: Facebook, baseUrl: "https://www.facebook.com/" },
    twitter: { name: "X (Twitter)", color: "bg-gray-800", brandIcon: Twitter, baseUrl: "https://www.twitter.com/" },
};


export const GEMINI_2_5_PRO_MODEL = "gemini-3.1-flash";
export const GEMINI_FLASH_MODEL = "gemini-2.5-flash";
